import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { ClientZS } from '../pages';
import ZieloneSzkolyFormPage from '../sections/landing/order-forms/ZieloneSzkolyFormPage';
import DocumentSigningPage from '../pages/guest/DocumentSigningPage';
import FormSentInfoOLRoute from '../components/form/FormSentInfoOLRoute';
import MainPage from '../pages/client-zs/MainPage';
import AccountSettings from '../pages/client-zs/AccountSettings';
import Documents from '../pages/client-zs/Documents';
import Payments from '../pages/client-zs/Payments';
import Event from '../pages/client-zs/Event';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/client-zs" />} />

    <Route path="/client-zs" element={<ClientZS />}>
      <Route path="" element={<MainPage />}/>
      <Route path="settings" element={<AccountSettings />}/>
      <Route path="documents" element={<Documents />}/>
      <Route path="payments" element={<Payments />}/>
      <Route path="event-details" element={<Event />}/>
    </Route>
    <Route path="zielone-szkoly" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2023" validPassword="zieloneszkoly2023sunsport"/>}/>
    <Route path="zielone-szkoly-2024" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2024" validPassword="2024sunsportzieloneszkoly" />}/>
    <Route path="zielone-szkoly-2025" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2025" validPassword="2025sunsportzieloneszkoly" />}/>
    <Route path="zielone-szkoly-2026" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2026" validPassword="2026sunsportzieloneszkoly" />}/>
    <Route path="zielone-szkoly-2027" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2027" validPassword="sunsportzieloneszkoly2027" />}/>
    <Route path=":id/sign_document/:annex_nr/:model" element={<DocumentSigningPage />}/>
    <Route
      path=":id/sign_document/:annex_nr/:model/:module_identifier"
      element={<DocumentSigningPage />}
    />
    <Route path="form-submitted" element={<FormSentInfoOLRoute/>}/>

  </Routes>
);
